<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$t(reportParameters[0].label)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="networkStartingPointOptions"
          :load-options="getNetworkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              technicalSiteLocalDisabled ||
              !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$t(reportParameters[1].label)">
        <input v-model="reportParameters[1].value" type="number" min="0" />
      </report-field>
      <report-field :field-name="$t(reportParameters[2].label)">
        <input v-model="reportParameters[2].value" type="number" min="0" />
      </report-field>
      <report-field :field-name="$t(reportParameters[3].label)">
        <input v-model="reportParameters[3].value" type="number" min="0" />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "OpticalBudgetReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "NetworkStartingPoint",
          key: "technical_local",
          type: "text",
          value: undefined
        },
        {
          label: "OutputPower",
          key: "output_power",
          type: "number",
          value: undefined
        },
        {
          label: "SpliceLoss",
          key: "splice_loss",
          type: "number",
          value: undefined
        },
        {
          label: "SplitterLoss",
          key: "splitter_loss",
          type: "number",
          value: undefined
        }
      ],

      historyFilter: "optical_budget"
    };
  },

  computed: {
    buttonsDisabled() {
      return (
        this.reportParameters[0].value === undefined ||
        this.reportParameters[1].value === undefined ||
        this.reportParameters[2].value === undefined ||
        this.reportParameters[3].value === undefined
      );
    },
    technicalSiteLocalDisabled() {
      return this.selectedWorkspace === undefined;
    },
    dataToSend() {
      return {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: {
            uuid: this.reportParameters[0].value,
            object_type: "technical_local"
          }
        }
      };
    }
  },

  watch: {
    selectedWorkspace() {
      this.reportParameters[0].value = undefined;
      this.networkStartingPointOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/OpticalBudget.vue